module.exports = __webpack_public_path__ + "static/procesDystrybucjaDesktop@x2-8749137236fbab0b7fdc2435848c49ec.png";